module.exports = __webpack_public_path__ + "img/notice.9a2a16f9.png";